import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AccountDetails = () => {

    const token = sessionStorage.getItem('token');

    const [account, setAccount] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch account details from server
    useEffect(() => {
        if (token) {
            fetchAccountDetails();
        } else {
            setError('No token found');
            setLoading(false);
        }
    }, []);

    const fetchAccountDetails = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_SRV}/adetail`, {
                headers: {
                    Authorization: `Bearer ${token}`,  // Send token in Authorization header
                },
            });

            if (response.status === 200) {
                const accountData = response.data;
                setAccount(accountData);  // Store the account data
            } else {
                setError('Failed to fetch account details');
            }
        } catch (error) {
            setError('An error occurred while fetching account details');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div>Loading account details...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="p-8 bg-gray-900 text-white min-h-screen">
            <div className="max-w-2xl mx-auto bg-gray-800 p-6 rounded-lg shadow-lg">
                <h2 className="text-3xl font-bold mb-4 text-golden">Account Details</h2>

                <div className="mb-4">
                    <label className="block text-gray-400">Name</label>
                    <p className="text-lg font-semibold">{account.name}</p>
                </div>

                <div className="mb-4">
                    <label className="block text-gray-400">Balance</label>
                    <p className="text-lg font-semibold">{account.balance}</p>
                </div>

                <div className="mb-4">
                    <label className="block text-gray-400">Features</label>
                    <ul>
                        {account.features && account.features.length > 0 ? (
                            account.features.map((feature) => (
                                <li key={feature._id} className="text-lg">
                                    {feature.name} {feature.value}
                                </li>
                            ))
                        ) : (
                            <li className="text-lg">No features available</li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default AccountDetails;
